import React, { useCallback } from "react";
import { IPetItemResponse } from "../../../../services/pet-list/pet-list.interface";
import { usePetStore } from "../../../../hooks/redux-hooks/pet-store/pet-store.service";
import { useModal } from "../../../../context/ModalContext";
import { MODALS } from "../../../../config/params";
import { useUrgentVisitStore } from "../../../../hooks/redux-hooks/urgent-visit-store/urgent-visit.store";
import {
  useAppointmentStore,
} from "../../../../hooks/redux-hooks/appointment-store/appointment.store";
import { useDispatch } from "react-redux";
import { toastMessageActions } from "../../../../state/request";
import PetSelection from "../../../../components/PetSelection/PetSelection";

const MAX_PETS = 3;

export const PetSelectionStep = () => {
  const { petList } = usePetStore();
  const { openModal } = useModal();
  const { selectedPets, setSelectedPets, rescheduleAppointmentId, petAppointmentMap } = useUrgentVisitStore();
  const {
    groupedAppointments, setAppointmentDetails,
  } = useAppointmentStore();
  const reduxDispatch = useDispatch();

  const petMapKeys = Object.keys(petAppointmentMap);

  const handleSelectPet = useCallback(
    (pet: IPetItemResponse) => {
      const isAlreadySelected = selectedPets.some((p) => p.id === pet.id);
      let newSelectedPets: IPetItemResponse[];

      if (isAlreadySelected) {
        newSelectedPets = selectedPets.filter((p) => p.id !== pet.id);
      } else if (selectedPets.length < MAX_PETS) {
        newSelectedPets = [...selectedPets, pet];
      } else {
        reduxDispatch(
          toastMessageActions.setGlobalAlert({
            severity: "error",
            message: `You can only book for ${MAX_PETS} pets at a time.`,
          }),
        );
        return;
      }

      setSelectedPets(newSelectedPets);

      // Sync appointmentDetails with the first selected pet's appointment
      if (
        petMapKeys.length > 1 &&
        newSelectedPets.length > 0 &&
        groupedAppointments
      ) {
        const matchingAppt = groupedAppointments.find(
          (appt) => appt.pet.id === newSelectedPets[0].id,
        );
        if (matchingAppt) {
          setAppointmentDetails(matchingAppt);
        }
      }
    },
    [
      selectedPets, setSelectedPets, reduxDispatch,
      petMapKeys, groupedAppointments, setAppointmentDetails,
    ],
  );

  const handleAddPet = () => {
    openModal(MODALS.ADD_A_PET);
  };

  const filteredPetList = petMapKeys.length > 1 ?
    (petList || []).filter((p) => petMapKeys.includes(p.id)) :
    petList;

  return (
    <PetSelection
      petsActive={filteredPetList}
      selectedPets={selectedPets}
      visitType={"Urgent Visit"}
      handleSelectPet={handleSelectPet}
      handleClickAddAPet={handleAddPet}
      hideAddPet={!!rescheduleAppointmentId}
    />
  );
};
